class Article {
  constructor () {
    this.heading = ''
    this.body = ''
  }
}

export class About {
  constructor (articleQty) {
    const articleLs = []

    for (let i = 0; i < articleQty; i++) {
      const article = new Article()
      articleLs.push(article)
    }

    this.introImage = {
      fileName: '',
      title: ''
    }
    this.title = ''
    this.intro = ''
    this.articles = articleLs
  }
}

export class Image {
  constructor () {
    this.fileName = ''
    this.title = ''
    this.portait = ''
    this.caption = ''
  }
}

export class Subsection {
  constructor (imageQty) {
    const imageLs = []

    for (var i = 0; i < imageQty; i++) {
      const image = new Image()
      imageLs.push(image)
    }

    this.name = ''
    this.id = ''
    this.backgroundImgFileName = ''
    this.images = imageLs
    this.previewImage = ''
  }
}

export class Section {
  constructor (subsectionQty, imageQty, previewImgQty) {
    const subsectionsLs = []
    const previewImgLs = []

    for (var i = 0; i < subsectionQty; i++) {
      const subsection = new Subsection(imageQty)
      subsectionsLs.push(subsection)
    }

    for (var j = 0; j < previewImgQty; j++) {
      const previewImg = new Image()
      previewImgLs.push(previewImg)
    }

    this.name = ''
    this.directory = ''
    this.subsections = subsectionsLs
    this.previewImages = previewImgLs
  }
}

export class Gallery {
  constructor (sectionQty, subsectionQty, imageQty, previewImgQty) {
    const sectionLs = []

    for (var i = 0; i < sectionQty; i++) {
      const section = new Section(subsectionQty, imageQty, previewImgQty)
      sectionLs.push(section)
    }

    this.title = ''
    this.description = ''
    this.sections = sectionLs
  }
}



// WEBPACK FOOTER //
// ./src/store/classes.js